import { render, staticRenderFns } from "./ReserveNotification.vue?vue&type=template&id=6c5dbd6a&scoped=true&"
import script from "./ReserveNotification.vue?vue&type=script&lang=js&"
export * from "./ReserveNotification.vue?vue&type=script&lang=js&"
import style0 from "./ReserveNotification.vue?vue&type=style&index=0&id=6c5dbd6a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5dbd6a",
  null
  
)

export default component.exports